export * from 'preact';
export { createPortal } from 'preact/compat';
export { ah as createContext, aa as flushSync } from './internal-common.js';



//////////////////
// WEBPACK FOOTER
// ./~/@fullcalendar/core/preact.js
// module id = Q8ri
// module chunks = 0